module.exports = __webpack_public_path__ + "media/images/app/become-vendor/strongbox-0d6cec3356aad28010a1f1702738d8ce.webp";